@if (isOpen()) {
  <div
    class="drawer"
    [ngStyle]="{ width: width() + 'px' }"
    >
    <app-ui-resize-handle (mousedown)="startResize($event)" class="resize-handle"></app-ui-resize-handle>
    @if (isEmpty()) {
      <div class="error-state">
        <div class="buttons">
          <app-ui-buttons-action-bar [actionButtons]="actionButtons()"></app-ui-buttons-action-bar>
        </div>
        <app-no-result-overlay [data]="noResultsOverlayDisplay()"></app-no-result-overlay>
      </div>
    } @else {
      <div class="drawer-header" [ngClass]="{'g-loader-flexible':isLoading()}">
        <ng-content select="app-ui-drawer-content-header"></ng-content>
        <app-ui-buttons-action-bar [actionButtons]="actionButtons()"></app-ui-buttons-action-bar>
      </div>
      @if (tabs() && (tabs()?.length || 0) > 0) {
        <div class="tabs-container" [ngClass]="{'g-loader-flexible':isLoading()}">
          <app-tabs [tabConfig]="tabConfig()" [tabs]="tabs()" (tabChanged)="onTabChanged($event)"></app-tabs>
        </div>
      }
      <div class="drawer-body" [ngClass]="{'g-loader-flexible':isLoading()}">
        <ng-content></ng-content>
      </div>
    }
  </div>
}

